// extracted by mini-css-extract-plugin
module.exports = {"logoWidthRestriction":"LogoContainer_logoWidthRestriction__2cbd7"};